import { X } from "lucide-react";

export function Modal({ title, onClose, onSubmit, children, testId, wide }) {
    return (
        <div className="fixed inset-0 bg-ink/70 z-50 flex items-center justify-center p-4" onClick={onClose}>
            <form
                data-testid={testId}
                onSubmit={(e) => { e.preventDefault(); onSubmit(); }}
                className={`bg-white w-full p-6 max-h-[90vh] overflow-y-auto ${wide ? "max-w-4xl" : "max-w-2xl"}`}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex items-center justify-between mb-4">
                    <h3 className="font-display text-2xl font-bold">{title}</h3>
                    <button type="button" onClick={onClose} aria-label="Close"><X /></button>
                </div>
                {children}
                <button type="submit" className="mt-5 w-full bg-primary text-white py-2.5 font-semibold hover:bg-primary-hover" data-testid={`${testId}-submit`}>Save</button>
            </form>
        </div>
    );
}

export function Field({ label, children }) {
    return (
        <label className="block text-sm">
            <span className="block text-xs uppercase tracking-wider text-muted-foreground mb-1">{label}</span>
            {children}
        </label>
    );
}

export const inputCls = "w-full border border-border px-3 py-2 text-sm bg-white";

export function StatusBadge({ value }) {
    const tone = {
        active: "bg-green-100 text-green-800", received: "bg-green-100 text-green-800", paid: "bg-green-100 text-green-800",
        ordered: "bg-amber-100 text-amber-800", partial: "bg-amber-100 text-amber-800", on_leave: "bg-amber-100 text-amber-800",
        unpaid: "bg-red-100 text-red-800", cancelled: "bg-red-100 text-red-800", terminated: "bg-red-100 text-red-800", inactive: "bg-gray-100 text-gray-700",
    }[value] || "bg-gray-100 text-gray-700";
    return <span className={`inline-block px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide ${tone}`}>{(value || "").replace("_", " ")}</span>;
}

export function fmtMoney(n, currency = "UGX") {
    return new Intl.NumberFormat("en-US", { style: "currency", currency, maximumFractionDigits: 0 }).format(Number(n || 0));
}
